<template>
    <div class="bg-red-600 text-white px-2 py-1" role="alert">
        <div class="flex">
            <div class="flex-1 text-center" name="hera-banner">
                <span class="not-found-heading">Sorry, Hera couldn't find the page you're looking for.</span><br>
                <h6 class="font-bold">If you clicked a button or were given a link to get to this page, please let us know!</h6>
                <h6 class="font-bold">Contact Hera Support using the chat bubble in the bottom-right corner of the page.</h6>
                <p>Error 404: The requested response was not found on the server.</p>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
};
</script>
<style scoped>
.not-found-heading{
  font-size: 30px;
  color: white 
}
</style>